import React, { useState, useEffect, useRef } from "react";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { backendApi } from "../../../api/apiService.js";
import { useSelector } from "react-redux";
import ThanksLogo from "../../../images/thanksupload.jpg";
import LOading from "../../../images/loadin_gif.gif";
import { useNavigate } from 'react-router-dom';

function FormComponent({ Qndata }) {
    const { candidateId } = useSelector((state) => state.login);
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [SubmitImage, setSubmitImage] = useState(false);
    const [Loader, setLoader] = useState(false);
    const [examTimePerQuestion, setExamTimePerQuestion] = useState(20);
    const currentQuestionIdRef = useRef(null);
    const candidateQuestionnaireIdRef = useRef(null);

    // GET ALL QUESTIONS

    useEffect(() => {
        if (Qndata) {
            setData(Qndata);
            setLoader(true);
            if (Qndata.Questions && Qndata.Questions.length > 0) {
                const totalExamTime = parseInt(Qndata.exam_time, 10);
                setExamTimePerQuestion(totalExamTime);
                updateRefs(0);
            }
        }
    }, [Qndata]);

    const updateRefs = (index) => {
        const question = data?.Questions[index];
        if (question) {
            currentQuestionIdRef.current = question.question_id;
            candidateQuestionnaireIdRef.current = data.candidate_questionnaire_id;
        }
    };


    useEffect(() => {
        updateRefs(currentQuestionIndex);
    }, [currentQuestionIndex, data?.Questions]);

    // MOVE TO THE NEXT QUESTION

    const handleNext = (candidateQuestionnaireId, questionId) => {
        console.log('Candidate Questionnaire ID:', candidateQuestionnaireId);
        console.log('Question ID:', questionId);
        if (currentQuestionIndex < (data?.Questions.length || 0) - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            const req = {
                functionName: "candidateQuestionnaireViewed",
                candidate_questionnaire_id: candidateQuestionnaireId,
                question_id: questionId
            };
            backendApi(req)
                .then((response) => {
                    if (response.success === "1") {
                        console.log(response.dataSet, "response.dataSet");
                    }
                })
                .catch((err) => {
                    console.log("error", err);
                });
        } else {
            console.log('End of questions');
        }
    };

    // HANDLE OPTION SELECTION
    const handleOptionChange = (answerId, QnId, CandteQnId) => {
        console.log(answerId, "answerId")
        console.log(CandteQnId, "candidateQuestionnaireId")
        console.log(QnId, "questionId")
        const req = {
            functionName: "candidateAnswerQuestion",
            candidate_questionnaire_id: CandteQnId,
            question_id: QnId,
            answer_id: answerId
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    console.log('Answer submitted successfully');

                }
            })
            .catch((err) => {
                console.log("error", err);
            });
    };

    // SUBMIT QUESTIONNAIRE

    const handleSubmit = async (candidateQuestionnaireId) => {
        try {
            console.log('Candidate Questionnaire ID:', candidateQuestionnaireId);
            const submitReq = {
                functionName: "candidateQuestionnaireSubmit",
                candidate_questionnaire_id: candidateQuestionnaireId,
            };
            const submitResponse = await backendApi(submitReq);
            if (submitResponse.success === "1") {
                setSubmitImage(true);
                setData(null)
                const viewedReq = {
                    functionName: "candidateQuestionnaireViewed",
                    candidate_questionnaire_id: candidateQuestionnaireId,
                    question_id: currentQuestionIdRef.current,
                };
                const viewedResponse = await backendApi(viewedReq);
                if (viewedResponse.success === "1") {
                    console.log(viewedResponse.dataSet, "response.dataSet");
                }
            }
        } catch (err) {
            console.log("error", err);
        }
    };

    // AUTO COMPLETE OF THE QUESTION TIME 

    const handleTimerComplete = () => {
        const questionId = currentQuestionIdRef.current;
        if (currentQuestionIndex === (data?.Questions.length || 0) - 1) {
            handleSubmit(data.candidate_questionnaire_id);
            handleNext(data.candidate_questionnaire_id, questionId);
        } else {
            handleNext(data.candidate_questionnaire_id, questionId);
        }
    };

    const currentQuestion = data?.Questions[currentQuestionIndex] || {};
    const options = currentQuestion.options || [];
    const isLastQuestion = currentQuestionIndex === (data?.Questions.length || 0) - 1;
    const handleHomeClick = () => {
        navigate('/candidate-assessmentHomePage');
    };
    
    //PREVENT COPY AND PASTE
    useEffect(() => {
        const handleCopy = (e) => e.preventDefault();
        const handleCut = (e) => e.preventDefault();
        const handlePaste = (e) => e.preventDefault();

        document.addEventListener('copy', handleCopy);
        document.addEventListener('cut', handleCut);
        document.addEventListener('paste', handlePaste);

        return () => {
            document.removeEventListener('copy', handleCopy);
            document.removeEventListener('cut', handleCut);
            document.removeEventListener('paste', handlePaste);
        };
    }, []);

    return (
        <>
            {!Loader ? (
                <div className="form-containerr">
                    <img src={LOading} alt="Loading"></img>
                </div>
            ) : (
                <>
                    {!SubmitImage ? (
                        <div className="form-containerr">
                            <h1 className="h1quiz">Quiz Question
                                <span className="h1quizspan">{currentQuestionIndex + 1}/{data?.Questions.length}</span>
                            </h1>
                            {currentQuestion ? (
                                <form>
                                    <div className="questionn">
                                        <p>{currentQuestion.question}</p>
                                        <br />
                                        <div className="form-groupp">
                                            {options.length > 0 ? (
                                                options.map((option) => (
                                                    <label key={option.question_options_id} className="custom-radio">
                                                        <input
                                                            type="radio"
                                                            name="option"
                                                            value={option.optionValue}
                                                            onChange={() => handleOptionChange(option.question_options_id, option.question_id, data.candidate_questionnaire_id)}
                                                        />
                                                        <span className="radio-label">{option.optionValue}</span>
                                                    </label>
                                                ))
                                            ) : (
                                                <p>Loading Questions</p>
                                            )}
                                        </div>
                                    </div>
                                    <br />
                                    {options.length > 0 ? (
                                        <div className="countdown-container">
                                            <CountdownCircleTimer
                                                key={currentQuestionIndex}
                                                isPlaying
                                                duration={examTimePerQuestion}
                                                colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                                                colorsTime={[15, 7, 4, 0]}
                                                size={90}
                                                strokeWidth={8}
                                                onComplete={handleTimerComplete}
                                            >
                                                {({ remainingTime }) => remainingTime}
                                            </CountdownCircleTimer>
                                            <div className="buttons">
                                                {isLastQuestion ? (
                                                    <button type="button"
                                                        onClick={() => handleSubmit(data.candidate_questionnaire_id)}
                                                        className="submit-button">
                                                        Submit
                                                    </button>
                                                ) : (
                                                    <button type="button"
                                                        onClick={() => handleNext(data.candidate_questionnaire_id, currentQuestion.question_id)}
                                                        className="submit-button">
                                                        Next
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ) : ""}
                                </form>
                            ) : (
                                <p>Loading questions...</p>
                            )}
                        </div>
                    ) : (
                        <>
                            <div className="form-containerr">
                                <img src={ThanksLogo} alt="Thank You"></img>
                            </div>
                            <a
                                onClick={handleHomeClick}
                                style={{ display: 'block', textAlign: 'center', marginTop: '20px', cursor: 'pointer' }}
                                className="home-link"
                            >
                                Home
                            </a>
                        </>
                    )}

                </>
            )}
        </>
    );
}

export default FormComponent;
